import type { ReactNode } from "react";

import CopyToClipboard from "../CopyToClipboard";

import { truncateIdForCell } from "./helpers";

export const DetailCardSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <section className="mb-4 rounded-md border border-stone-200 bg-white p-4">
    <h3 className="mb-3 text-sm font-medium text-stone-800">{title}</h3>
    {children}
  </section>
);

export const DetailList = ({ children }: { children: ReactNode }) => (
  <div className="divide-y divide-stone-100">{children}</div>
);

export const DetailRow = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className="flex items-center justify-between gap-4 py-2 text-sm">
    <span className="shrink-0 text-stone-600">{label}</span>
    <div className="flex min-w-0 items-center justify-end gap-2 text-right break-all text-stone-800">{value}</div>
  </div>
);

export const IdValue = ({ id }: { id: string }) => (
  <>
    <span className="rounded-md bg-stone-100 px-2 py-0.5 font-mono text-xs text-stone-600">{id}</span>
    <CopyToClipboard textToCopy={id} />
  </>
);

export const IdCell = ({ id, full = false }: { id: string; full?: boolean }) => (
  <span className="rounded-md bg-stone-100 px-2 py-0.5 font-mono text-xs text-stone-600" title={id}>
    {full ? id : truncateIdForCell(id)}
  </span>
);
